import React from 'react';
import { getPublicImageUrl } from '../../utils/storage';
import styles from './LandingPage.module.css';

function initialsFromName(name) {
  if (!name) return '?';
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('');
}

function resolvePhoto(instructor) {
  const raw =
    instructor?.photo_url ||
    instructor?.profile_image_url ||
    instructor?.image_url ||
    instructor?.avatar_url ||
    '';
  if (!raw) return null;
  if (String(raw).startsWith('http')) return raw;
  return getPublicImageUrl(raw, 'instructor-images') || raw;
}

export default function Instructors({ instructors = [], language = 'en' }) {
  if (!instructors.length) return null;

  const lang = String(language).toLowerCase();
  const eyebrow = lang === 'es' ? 'Presentadores' : 'Speakers';
  const title = lang === 'es' ? 'Conoce a los instructores' : 'Meet Your Instructors';

  return (
    <section className={`${styles.section} ${styles.sectionAlt}`}>
      <div className={styles.container}>
        <header className={styles.sectionHeader}>
          <p className={styles.sectionEyebrow}>{eyebrow}</p>
          <h2 className={styles.sectionTitle}>{title}</h2>
        </header>
        <div className={styles.instructorsGrid}>
          {instructors.map((i, idx) => {
            const name = i.full_name ?? i.name ?? 'Instructor';
            const photo = resolvePhoto(i);
            const role = i.role ?? i.title ?? '';
            return (
              <div key={i.instructor_id ?? i.id ?? idx} className={styles.instructorCard}>
                <div className={styles.instructorPhoto}>
                  {photo ? (
                    <img src={photo} alt={name} loading="lazy" />
                  ) : (
                    initialsFromName(name)
                  )}
                </div>
                <div className={styles.instructorName}>{name}</div>
                {role ? <span className={styles.instructorRole}>{role}</span> : null}
                {i.bio ? <p className={styles.instructorBio}>{i.bio}</p> : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
